import { useState, type FormEvent } from 'react'
import { useAuth } from '@/auth/useAuth'
import { env } from '@/config/env'
import { isTelegramEnvironment } from '@/lib/telegram'
import { Button, Input, Spinner } from '@/ui'

/** Shown when there is no valid session. In Telegram, login is automatic. */
export function LoginPage() {
  const { status, error, loginWithTelegram, loginWithBootstrap } = useAuth()
  const inTelegram = isTelegramEnvironment()
  const [secret, setSecret] = useState('')

  function submitBootstrap(e: FormEvent) {
    e.preventDefault()
    if (secret.trim()) void loginWithBootstrap(secret.trim())
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-5 px-6 text-center">
      <div className="text-2xl font-bold text-tg-text">{env.appName}</div>
      <p className="text-sm text-tg-hint">Управление мебельным производством</p>

      {status === 'loading' ? (
        <Spinner />
      ) : (
        <div className="w-full space-y-5">
          {error && <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-risk-red">{error}</p>}

          {inTelegram && (
            <Button onClick={() => void loginWithTelegram()} fullWidth>
              Войти через Telegram
            </Button>
          )}

          {/* Browser admin access (works only if the server has bootstrap login enabled). */}
          <form onSubmit={submitBootstrap} className="space-y-2 text-left">
            <p className="text-sm font-medium text-tg-text">Вход администратора</p>
            <Input
              type="password"
              autoComplete="current-password"
              placeholder="Секрет доступа"
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
            />
            <Button type="submit" fullWidth disabled={!secret.trim()}>
              Войти
            </Button>
            <p className="text-xs text-tg-hint">
              Для первичной настройки бизнеса в браузере. Сотрудники входят через Telegram-бота.
            </p>
          </form>
        </div>
      )}
    </div>
  )
}
